/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { GetAnimalQueryResponse, GetAnimalPathParams, GetAnimal400, GetAnimal401, GetAnimal403, GetAnimal404, GetAnimal409, GetAnimal500 } from "../../types/livestockController/GetAnimal.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getGetAnimalUrl(organizationId: GetAnimalPathParams["organizationId"], animalId: GetAnimalPathParams["animalId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/livestock/animals/${animalId}` as const }
  return res
}

/**
 * @summary Get animal profile
 * {@link /api/organizations/:organizationId/livestock/animals/:animalId}
 */
export async function getAnimal(organizationId: GetAnimalPathParams["organizationId"], animalId: GetAnimalPathParams["animalId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetAnimalQueryResponse, ResponseErrorConfig<GetAnimal400 | GetAnimal401 | GetAnimal403 | GetAnimal404 | GetAnimal409 | GetAnimal500>, unknown>({ method : "GET", url : getGetAnimalUrl(organizationId, animalId).url.toString(), ... requestConfig })
  return res.data
}